<template>
  <div class="page page-home">
    <div class="posters-wrapper">
      <div class="poster poster-image" style="margin-bottom: 0">
        <img src="@/assets/2026/Berget-2026.jpg" />
      </div>
      <div class="poster poster-video" style="margin-bottom: 0">
        <router-link to="/story">
          <video src="@/assets/2026/movie5.mp4" poster="@/assets/2026/moviePoster.jpg" autoplay playsinline muted loop style="max-width: 1600px; width: 100%; height: auto;"/>
        </router-link>
      </div>
    </div>

    <div class="poster" style="max-width: 1280px; margin: auto; margin-bottom: 60px;" v-if="0">
      <div style="padding:56.25% 0 0 0;position:relative; width: 100%;">
        <iframe src="https://player.vimeo.com/video/884900401?badge=0&amp;autopause=0&amp;quality_selector=1&amp;player_id=0&amp;app_id=58479" frameborder="0" allow="autoplay; fullscreen; picture-in-picture" style="position:absolute;top:0;left:0;width:100%;height:100%;" title="B20teaserfinal"></iframe>
        <script type="application/javascript" src="https://player.vimeo.com/api/player.js"></script>
      </div>
    </div>

    <div class="segment bg-brown">
      <div class="content narrow" style="padding-top: 0;padding-bottom: 0">
        <div class="post no-bg" style="padding-top: 0;padding-bottom: 0;margin-bottom: 0">
          <div class="post-content-wrapper big-text">

            <div class="post-header text-highlight-red">BERGET 22 <span
              style="color:white"> - OPERATION FORT KNOX</span></div>
            <pre class="post-content">
              This year, we're taking the game back to one of the most beloved battlefields in Berget history - a location praised for its excellent road network, close proximity to a city, and varied, immersive terrain. It's a game area that many players have asked for, and now it's time to return.

              We're also evolving how the game is played. LARP and civilian roles will take on a bigger part in the story, influencing missions and creating a more dynamic, living world. Every action will matter - whether you're a soldier, trader, gangster, or a politician.. Capture Points will still be tactical, but it's our goal to make missions feel more meaningful and the results more impactful.

              A new storyline and reworked factions are being introduced, designed to ensure better balance, realism, and player cooperation. The goal: fair, engaging, and unforgettable gameplay for everyone involved.

              BAVS are getting further development, and among other things we are tweaking the balance slightly more in favour of vehicles. We are doing this by limiting the rate and number of reloads to ensure a more fun playing experience for all.

              With your feedback we will also continue to build on the level of action and excitement that comes from both epic large scale battles and intense smaller skirmishes. One of the most positive points of feedback from last year was that the game started in highest gear with big battles on all fronts.

              <b>Berget 22 tickets are available!</b>
              Get your ticket on the <a href="https://berget-portal.com/">Berget Portal</a>
              The tickets will be sold at a 40€ discount the first night to the price of 159€. After the first night the ticket price will be raised to 199€.

              <a href="https://berget-portal.com/" class="buy-tickets-here">BUY TICKETS HERE!</a>
              <img src="@/assets/2026/tickets.jpg" style="width: 100%; margin-top: 20px;"/>

            </pre>
            <div class="post-date">2025.10.26 - 20:00 CET (GMT +2)</div>
          </div>
        </div>
      </div>
    </div>

    <div class="segment" v-if="news.length > 1">
      <div class="content">
        <div class="header">LATEST <span class="text-highlight">NEWS</span></div>

        <div class="post" v-for="post in news" :key="post.Id">
          <div v-if="post.Cover.length > 0" class="image"><img :src="getImageURL(post)"></div>
          <div class="post-content-wrapper">
            <div class="post-header">{{ post.Title }}</div>
            <pre class="post-content" v-html="post.Content"></pre>
            <div class="post-date">{{ formatDate(post.Date) }}</div>
          </div>
        </div>

      </div>
    </div>

  </div>
</template>

<script>
export default {
  name: 'Home',
  data () {
    return {
      news: [{
        Id: '12',
        Title: 'Game-area map and Pre-order shop',
        Cover: [{ path: 'img/2026/map_news.jpeg' }],
        Content: `Berget 22 is approaching and we wanted to announce that the map for this year's game area is ready. If you haven't ordered a map from us, you can download it here in digital format.

<a target="_blank" href="https://berget-events.com/B22_A3.pdf">B22_A3.pdf</a>

Also remember that you can pre-order airsoft gear and have it delivered to you in the shop at the event. You can order here.

<a target="_blank" href="https://www.tacticalstore.se/?lang=en">https://www.tacticalstore.se/?lang=en</a>`,
        Date: '2026-06-08 22:00'
      }, {
        Id: '11',
        Title: 'Updated Rules for Berget 2026',
        Cover: [{ path: 'img/2026/bergetRules.jpeg' }],
        Content: `The updated rules for Berget 2026 are now available. Read about gold bars and the armed gold bunkers here.

<a target="_blank" href="https://berget-events.com/BergetRules2026.pdf">BergetRules2026.pdf</a> and <a target="_blank" href="https://berget-events.com/Chrono2026.pdf">Chrono2026.pdf</a>`,
        Date: '2026-04-19 22:19'
      }, {
        Id: '10',
        Title: 'Gang Leaders Announced',
        Cover: [{ path: 'img/2026/gangs.jpeg' }],
        Content: `We have now selected the leaders of the two criminal gangs.

Johan, takes the role of leader of the criminal syndicate Sons of the North (Black & White armband). Johan has been leader on previous Berget and other airsoft games.

For info and to start your planning

Contact info:
johan.albin@hotmail.com

Discord: snowman_airsoft_sweden

Angie takes the role of leader of the motorcycle gang Odin's Wolves MC (Red & White armband). Daughter of the murdered president of the motorcycle club.

Angie has been a leader of civilian groups and played a nun on previous Berget.

Contact info:
Discord: Angie7783
Email: Angelicaarkhall1@gmail.com`,
        Date: '2026-03-10 19:00'
      }, {
        Id: '9',
        Title: 'Commanders and Civilian Leaders Announced',
        Cover: [{ path: 'img/2026/commander.jpeg' }],
        Content: `We have now chosen the main commanders and also the leaders of the civilian groups. We start here by presenting:

Henrik as Commander for Blue team "Nordland Defence Group"

Henrik from Sweden who has several years of experience of HQ on Berget and other games. He has expanded his HQ staff with new experienced people.

For questions about your team organization and mission:

Contact info:
hq.nordisec@gmail.com or Discord N-85GIS



Igoris as Commander for Yellow Team "Mercenaries"

Igoris from Lithuania also has several years of experience of being a commander on Berget and other games.

For questions about your team organization and mission:

Contact info:
Telegram: @igoris
Email: igariokas@me.com
Discord: r.igoris`,
        Date: '2026-03-04 21:00'
      }, {
        Id: '8',
        Title: 'Gold vault (Special Fortified Position)',
        Cover: [{ path: 'img/vault.jpeg' }],
        Content: `There will be two (2) GOLD vaults in the game area.

Each vault is equipped with crew-operated machineguns. These machineguns cannot be eliminated by regular BB hits.

The Vault is fitted with a BAVS receiver mounted on the roof.
When the Vault receives a penetrating BAVS hit, the machineguns are disabled for exactly 4 minutes. After 4 minutes they automatically restart (Crew operated). The vault can withstand multiple AT hits and must be reduced to zero health again for each new 4-minute disable period.

<b>Access & Destruction</b>
The Vault door is secured by a magnetic lock.

The door can only be opened by:
 - A valid KEYCARD, or
 - A Berget-issued TNT prop explosive (with NFC).

Only TNT provided and approved by Berget may be used (NFC TAG). Standard engineer explosives have no effect on the vault door.
The vault door must be fully opened before engagement inside.
The vault is not a re-spawn location.

When the door opens, a roof-mounted siren activates, alerting all nearby players that the vault has been breached.
All machine-guns on-top will go offline.
Inside the vault there will be an unknown quantity of GOLD and possibly additional defensive elements. All vault interactions are subject to GM supervision.

<b>Gold vault - Underground Recharge</b>

The Vault sits on an automated subterranean extraction mechanism (Story-wise).
When emptied, the system must complete a recharge cycle before new gold can surface.

So if a group/team manages to empty the surface vault from its Gold. It will be a 6 hour cooldown for next cycle to start.

Each Vault can be looted 2 times per day, giving the object value for more players. The "Online-map" will indicate when a vault is Active (with gold) or on cooldown.

More info in the upcomming Rules 2026 update`,
        Date: '2026-02-17 20:00'
      }, {
        Id: '7',
        Title: 'Tanks are Back!',
        Cover: [{ path: 'img/tanks.jpeg' }],
        Content: `Those of you who haven't been to a Berget game and experienced how the ground shakes and how the rumble of the engines terrifies the inexperienced player when a Tank approaches your firing position... you've missed something.

The Tanks are back on Berget 22 and they will be more dangerous than ever, as we have chosen to add a secondary HIT receiver that sits on the back of the Tank. More info in the rules update.

A Tank in airsoft is a breakthrough vehicle, and if your teammates don't have mines or any of Berget's anti-tank weapons, it is not possible to stop a Tank.

As a participant, you can (in limited supply) rent anti-tank weapons when you book your ticket. With this weapon you can damage and completely destroy a Tank. These work with lasers that hit the Tank's receiver and damage it until it is knocked out, sort of like laser tag.`,
        Date: '2026-02-12 21:30'
      }, {
        Id: '6',
        Title: 'Game Area Announced!',
        Cover: [{ path: 'img/gamearea2026.jpeg' }],
        Content: 'We are happy to announce the game area for Berget 22, all contracts with landowners are signed. As previously mentioned we are moving back closer to the city to hold the game at Remsle just north of Sollefteå city. The area has great base locations, perfect cell and radio reception, interesting and varied terrain and an abundance of roads. Vehicle and Tank play will be much better due to road network. Since the area is rather large we are focusing on placing objectives and bases in a new manner that will make the game fun and accessible both by foot and vehicle. <br><br> GPS location to Safezone: 63°10\'52.1"N 17°17\'02.8"E <a href="https://maps.app.goo.gl/sb2LU54igNc9k5mD6">Google Maps</a>',
        Date: '2026-01-18 21:00'
      }, {
        Id: '5',
        Title: 'Ticket Update!',
        Cover: [{ path: 'img/ticketUpdate.jpg' }],
        Content: `We are aware that the current economic climate is hard on many people and after some good feedback we have decided to prolong the normal 30 day payment time of our tickets up to 60 days. We will also prolong the second ticket price step by a few months.
To sum it up, tickets are released at the discounted price of 159€ the first night of 17th November 20:00 CET. After the first night all tickets will cost 189€.  All tickets booked have up to 60 days to be paid.`,
        Date: '2024-11-14 10:55'
      }],
      newsExample: []
    }
  },
  methods: {
    async loadNews () {
      const response = await fetch('https://berget-events.com/db/news')
      const result = await response.json()
      result.list.sort((a, b) => {
        return a.Id > b.Id ? -1 : 1
      })
      this.news = result.list
    },
    formatDate (date) {
      const time = date.substring(10, 16) + ' CET (GMT +1)'
      const prettyDate = date.substring(0, 10).replace(/-/g, '.')
      return `${prettyDate} - ${time}`
    },
    getImageURL (post) {
      const img = post.Cover[0] || {}
      if (img.url) return img.url
      if (img.path) return img.path.replace('download/', 'https://berget-events.com/uploads/')
    }
  },
  created () {
    this.loadNews()
  }
}
</script>

<style scoped>
.buy-tickets-here { font-weight: 800; font-size: 3em; color: #E64020 }
</style>
